/**
 * commentReport
 */

import Config from '../../Config';
import Util from '../../Util';
import Template from '../Template';

let INSTANCE: CommentReport;

class CommentReport {
  private $id: string;

  private $appendNode: string;

  private articleId: string;

  private commentId: string;

  private _id: string;

  private maxCount: number = 20;

  private $node: any;

  private $parent: any;

  private $modal: any;

  private writer: string;

  private emoticonUrl: string;

  constructor($parent: any, $appendNode: any, articleId: string) {
    this.$id = 'ncCommunityCommentReport';
    this.$appendNode = $appendNode;
    this.$parent = $parent;
    this._id = this.$parent.attr('id');
    this.$node = jQuery(Template.report(this.$id, 'comment'));
    this.$modal = jQuery(Template.modal(this.$id + 'Modal'));
    this.articleId = articleId || Util.getParams().articleId;
    this.commentId = '';
    this.writer = '';
    $appendNode.append(this.$modal, this.$node);
    this.addEvent();

    if (!INSTANCE) {
      INSTANCE = this;
    }

    return INSTANCE;
  }

  public show() {
    // 모든 layer hide
    jQuery('.co-layer-container').removeClass('is-active');
    jQuery('.co-layer-modal').removeClass('is-active');

    jQuery(`#${this.$id} input[type=radio]:eq(0)`).prop('checked', true);

    this._reportedCount((data: any) => {
      if (data.result || data.result === '0' || data.result === 0) {
        data = data.result;
      }

      if (data !== this.maxCount && data !== -1) {
        this.$node.find('.wrap-count .count').text(this.maxCount - data);
        this.$node.find('.target').text(this.writer);
        this.$node.addClass('is-active');
        this.$modal.addClass('is-active');
      } else if (data === -1) {
        Config.alert(Config.L10N.report_already_have_done);
      } else {
        Config.alert(Config.L10N.report_info);
      }
    });
  }

  public hide() {
    this.$node.removeClass('is-active');
    this.$modal.removeClass('is-active');
  }

  private _reportedCount(callback: any) {
    const getPromise: any = Util.get(Config.todayReportedCount(), 'GET');
    getPromise.then(
      (data: any) => {
        if (callback) {
          callback(data);
        }
      },
      (data: any) => {
        Config.apiError(data);
      }
    );
  }

  private addEvent() {
    // 메뉴
    jQuery('body').on('click', `#${this._id} .ncCommentCommonWrap .btn-declare`, evt => {
      evt.preventDefault();
      const _$this = jQuery(evt.currentTarget);

      this.emoticonUrl = _$this.attr('data-emoticonUrl') || '';
      this.writer = _$this.attr('data-commentuser') || '';

      if (this.emoticonUrl && this.emoticonUrl.toString() === 'true') {
        this.writer = `<img src="${_$this.attr('data-commentuser')}" alt="" />`;
      }

      this.commentId = _$this.attr('data-commentid') || '';

      if (Config.isBnsApp) {
        const reportType = 1;
        location.href = `${Config.app.report}?report_type=${reportType}&report_id=${this.commentId}&writer=${this.writer}`;
      } else if (Config.isMobileSdk) {
        location.href = Config.mobileSdk.report(this.commentId);
        return;
      } else {
        this.show();
      }
    });

    // 닫기 버튼
    jQuery('body').on('click', `#${this.$id} .co-btn-close`, evt => {
      evt.preventDefault();
      this.hide();
    });

    // 취소 버튼
    jQuery('body').on('click', `#${this.$id} .reportCancel`, evt => {
      evt.preventDefault();
      this.hide();
    });

    // need to work L10N msg
    jQuery('body').on('click', `#${this.$id} .reportFinish`, evt => {
      evt.preventDefault();
      const value = jQuery(':radio[name="reportCase"]:checked').val();

      if (!value) {
        Config.alert(Config.L10N.report_reason);
        return;
      }

      this.submit(
        {
          reason: value
        },
        (data: any) => {
          if (data === -1) {
            Config.alert(Config.L10N.report_already_have_done);
          } else {
            Config.alert(Config.L10N.report_have_done);
          }
          this.hide();
        }
      );
    });
  }

  private submit(data: any, callback: any) {
    const _post = Util.get(
      Config.reportComment({
        board: Config.board,
        articleId: this.articleId,
        commentId: this.commentId
      }),
      'POST',
      data
    );
    _post.then(
      (result: any) => {
        if (callback) {
          callback(result);
        }
      },
      (result: any) => {
        Config.apiError(result);
      }
    );
  }
}

export default CommentReport;
